// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var AttachmentsSettingsController = function ($scope, $routeParams, gettext, gettextCatalog, Attachment) {
    $scope.convert = Attachment.get();

    $scope.removeStep = function (id) {
        $scope.yesCancel(gettextCatalog.getString(gettext('Delete Attachment')),
            gettextCatalog.getString(gettext('Are you sure?')),
            function () {
                Attachment.remove({ attachmentId: id }, function () { $scope.convert = Attachment.get();});
            });
    };
};

AttachmentsSettingsController.$inject = ['$scope', '$routeParams', 'gettext', 'gettextCatalog', 'Attachment'];
